import {Injectable} from '@angular/core';
import {GlobalEventDispatcherService} from "../global-event-dispatcher/global-event-dispatcher.service";
import {GlobalEvent} from "../global-event-dispatcher/global-event";
import {RequestRepeatData} from "./request-repeat-data";
import {Config} from "../../../config/config";
import { HttpClient, HttpEvent, HttpRequest, HttpResponse } from '@angular/common/http';
import {DbResponse} from "../../interceptors/db-response";
import {Subject} from 'rxjs';
import {TypeUtils} from "../../utils/type-utils";
import {environment} from "../../../../environments/environment";
import {first} from "rxjs/operators";

@Injectable()
export class RequestRepeaterService {

  private _waitingRequests: RequestRepeatData[];

  constructor(
    private _httpClient: HttpClient,
    private _globalEventDispatcher: GlobalEventDispatcherService,
  ) {
    this._waitingRequests = [];

    this._globalEventDispatcher.addEventListener(GlobalEvent.requestFailedSessionTimeout, this.onRequestFailedSessionTimeout, this);
    this._globalEventDispatcher.addEventListener(GlobalEvent.requestFailedWrongToken, this.onRequestFailedWrongToken, this);
    this._globalEventDispatcher.addEventListener(GlobalEvent.sessionRefreshed, this.onSessionRefreshed, this);
    this._globalEventDispatcher.addEventListener(GlobalEvent.sessionRefreshFailed, this.onSessionRefreshFailed, this);
  }

  private onRequestFailedSessionTimeout(request: HttpRequest<any>, observable: Subject<any>): void {
    this._waitingRequests.push(new RequestRepeatData(request, observable));
  }

  private onRequestFailedWrongToken(request: HttpRequest<any>, observable: Subject<any>): void {
    this._waitingRequests.push(new RequestRepeatData(request, observable));
    this.repeatNextWaitingRequest();
  }

  private onSessionRefreshed(): void {
    if (this._waitingRequests.length) {
      this.repeatNextWaitingRequest();
    }
  }

  private onSessionRefreshFailed(response: any): void {
    this._waitingRequests.forEach((requestData: RequestRepeatData): void => {
      const _response = TypeUtils.cloneDeep(response);
      if (response && response.status && response.url && response.url === `${environment.coreEndpoint}/refresh` && response.status === 422 && response.error.error.message === "422 Unprocessable Entity") {
        _response.error.error.message = "You are logged out, please login again.";
      }

      requestData.observable.error(_response);
    });
    this._waitingRequests = [];
  }

  private repeatNextWaitingRequest(): void {
    const userAccessToken: string | null = localStorage.getItem('dbUserAccessToken');

    if (userAccessToken) {
      const requestData: RequestRepeatData = this._waitingRequests.shift();
      const request: HttpRequest<any> = requestData.request.clone({
        setHeaders: {
          'authorization': `Bearer ${userAccessToken}.${Config.serviceKey}`
        }
      });
      const responseObservable: Subject<any> = requestData.observable;

      this._httpClient
        .request<HttpResponse<any>>(request)
        .pipe(first())
        .subscribe((response: HttpEvent<HttpResponse<DbResponse>>): void => {
          responseObservable.next(response['response']);
        });

      if (this._waitingRequests.length) {
        this.repeatNextWaitingRequest();
      }
    } else {
      console.error('User access token not found.');
      // Optionally handle the case when the token is missing (e.g., trigger re-authentication)
    }

  }

}
